export const passwordReset = {
  passwordResetHeader: "Password Reset",
  passwordResetText:
    "Enter your email address and we will send you a link to reset your password.",
  passwordResetButtonText: "Reset Password",
  passwordResetTokenText: "Password reset link has been sent.",
  passwordResetLinkText: "Please check your inbox for password reset link"
};
